// OPTIMIZELY REMOVED: All imports removed since they're no longer needed in stub implementation

type ActivateListenerPayload = any
type FullStackTrackable = any

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function onActivate(_activateObject: ActivateListenerPayload) {
  // No-op function - Optimizely tracking disabled
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const track = (_event: FullStackTrackable) => {
  // No-op function - Optimizely tracking disabled
}

// eslint-disable-next-line import/no-mutable-exports
export const resolveRioPromise = () => {}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const initialize = (_cookieDomain: string) => {
  return null
}

export default initialize